import React, { useEffect } from "react";
import { useState } from "react";
import IOSSwitch from "../IOSSwitch";
import { useStyles } from "./ModoAdultoMayorStyles";
import { connect, ConnectedProps } from "react-redux";
import * as actionCreators from "../../../../store/actions";
import { isNative2 } from "../../../../utils/helper";

const mapDispatchToProps = (dispatch: any) => ({
  toggleModoAdultoMayor: (idAplicacion: boolean) =>
    dispatch(actionCreators.toggleModoAdultoMayor(idAplicacion)),
});

const mapStateToProps = (state: any) => ({
  modoMayor: state.usuario.user.modoMayor,
  modoMayorManual: state.usuario.user.modoMayorManual,
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type Props = ConnectedProps<typeof connector>;

const ModoAdultoMayor: React.FC<Props> = (props) => {
  const { modoMayor, toggleModoAdultoMayor } = props;
  const [esNativo, setEsNativo] = useState(false);
  const clases = useStyles();

  useEffect(() => {
    const checkIsNative = async () => {
      const result = await isNative2();
      setEsNativo(result);
    };
    checkIsNative();
  }, []);

  const handleClick = () => {
    toggleModoAdultoMayor(!modoMayor);
  };

  if (!esNativo) return null;

  return (
    <div className={clases.container}>
      <section className={clases.info}>
        <h2>Modo Persona Mayor</h2>
        <p>
          Interfaz adaptada para adultos mayores con información y mejor
          accesibilidad.
        </p>
      </section>
      <IOSSwitch
        checked={modoMayor}
        onChange={handleClick}
        name="modoAdultoMayor"
      />
    </div>
  );
};

export default connector(ModoAdultoMayor) as React.ComponentType;
